export enum AnalyticsEvent {
  PAGE_VIEW = 'page_view',
  CUSTOM_EVENT = 'custom_event'
}

export enum AnalyticsPageType {
  CUSTOMER_PORTAL_DASHBOARD = 'customer_portal_dashboard', // Customer Portal
  CUSTOMER_PORTAL_ORDER_DETAILS = 'customer_portal_order_details',
  CUSTOMER_PORTAL_USER_DETAILS = 'customer_portal_user_details',

  MARKETING_PORTAL_DASHBOARD = 'marketing_portal_dashboard', // Marketing Portal
  MARKETING_PORTAL_OFFER_DETAILS = 'marketing_portal_offer_details',

  RESTAURANT_LIST = 'restaurant_list', // Restaurant Management
  RESTAURANT_DETAILS = 'restaurant_details',
  RESTAURANT_ADD = 'restaurant_add',
  RESTAURANT_EQUIPMENT = 'restaurant_equipment',
  RESTAURANT_READY_TO_ROLL = 'restaurant_ready_to_roll',
  RESTAURANT_READY_TO_ROLL_ADD = 'restaurant_ready_to_roll_add',
  RESTAURANT_READY_TO_ROLL_VIEW = 'restaurant_ready_to_roll_view',
  RESTAURANT_READY_TO_ROLL_REPORT = 'restaurant_ready_to_roll_report',
  RESTAURANT_TRADING_HOURS = 'restaurant_trading_hours', // Trading Hours
  RESTAURANT_TRADING_HOURS_UPDATE = 'restaurant_trading_hours_update',
  RESTAURANT_TRADING_HOURS_TEMPORARY = 'restaurant_trading_hours_temporary',
  RESTAURANT_TRADING_HOURS_PERMANENT = 'restaurant_trading_hours_permanent',

  FRANCHISE_HUB_LIST = 'franchise_hub_list', // Franchise Hub
  FRANCHISE_HUB_ADD = 'franchise_hub_add',
  FRANCHISE_HUB_DETAILS = 'franchise_hub_details',
  FRANCHISE_HUB_REVIEW_SIGNOFF = 'franchise_hub_review_signoff',
  FRANCHISE_HUB_REVIEW_SUBMISSION = 'franchise_hub_review_submission',

  USER_MANAGEMENT_DASHBOARD = 'user_management_dashboard', // User Management
  USER_MANAGEMENT_ROLES = 'user_management_roles',
  USER_MANAGEMENT_PERMISSIONS = 'user_management_permissions',

  ORDER_MANAGEMENT_DASHBOARD = 'order_management_dashboard', // Order Management

  OPERATIONS_STORE_SURCHARGES = 'operations_store_surcharges', // Operations
  OPERATIONS_MASTER_PRICING_LIST = 'operations_master_pricing_list',

  SUBMISSIONS_DASHBOARD = 'submissions_dashboard', // Submissions (AWRTR)
  SUBMISSIONS_READY_TO_ROLL = 'submissions_ready_to_roll',
  SUBMISSIONS_RSS = 'submissions_rss',
  SUBMISSIONS_CLEANING_SHEET = 'submissions_cleaning_sheet',

  FAQ_DASHBOARD = 'faq_dashboard', // FAQ & Support
  FAQ_CATEGORY = 'faq_category',
  FAQ_DETAILS = 'faq_details',

  HISTORY_LOGS = 'history_logs', // History & Logs
  HISTORY_LOGS_DETAILS = 'history_logs_details',

  DISABLED_INGREDIENTS = 'disabled_ingredients', // Disabled Ingredients
  DISABLED_INGREDIENTS_ADD = 'disabled_ingredients_add',
  DISABLED_INGREDIENTS_EDIT = 'disabled_ingredients_edit',

  PRODUCTS_LIST = 'products_list', // Products
  PRODUCTS_DETAILS = 'products_details',
  PRODUCTS_PRICING = 'products_pricing',

  LOGIN = 'login', // Authentication
  REGISTER = 'register',
  FORGOT_PASSWORD = 'forgot_password',
  RESET_PASSWORD = 'reset_password',

  ERROR_404 = 'error_404', // Error Pages
  ERROR_401 = 'error_401',
  ERROR_500 = 'error_500'
}
